import * as React from 'react';
import { PaymentInstructionLayout } from '../../../component/PaymentInstructionLayout.js';

const ApplePay = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.applepay.info"
    });
};

export { ApplePay };
//# sourceMappingURL=ApplePay.js.map
